/**
 * PAPPO — Alert & Risk Classification types
 * Tipos para o sistema de monitorização parental
 */

/** Categorias de risco analisadas pela IA (Groq) */
export type RiskCategory =
  | 'safe'
  | 'bullying'
  | 'violence'
  | 'scam'
  | 'sexual_content'
  | 'grooming'
  | 'self_harm'
  | 'drugs';

/** Níveis de risco (1-5) */
export type RiskLevel = 1 | 2 | 3 | 4 | 5;

/** Classificação de risco de uma mensagem */
export interface RiskClassification {
  id: number;
  message_id: number;
  risk_category: RiskCategory;
  risk_level: RiskLevel;
  justification: string | null;
  model_used: string | null;
  processed_at: string;
}

/** Status do alerta ('resolved' = ação tomada; 'dismissed' = falso alarme) */
export type AlertStatus = 'pending' | 'seen' | 'dismissed' | 'resolved';

/** Contato do filho na conversa sinalizada (com quem ele falava) */
export interface AlertContact {
  id: number;
  name: string;
  role: 'child' | 'parent' | 'admin';
}

/** Alerta para o painel parental */
export interface Alert {
  id: number;
  risk_classification_id: number;
  parent_user_id: number;
  child_user_id: number;
  status: AlertStatus;
  seen_at: string | null;
  created_at: string;
  /** Populated by API join */
  classification?: RiskClassification;
  /** Child display name for UI */
  child_name?: string;
  /** Conteúdo da mensagem sinalizada (populated by API join) */
  message_content?: string;
  /** Conversa onde a mensagem foi enviada (para "Ver conversa") */
  conversation_id?: number | null;
  /** True se a conversa é um grupo (sem "contato" único) */
  is_group?: boolean;
  /** Com quem o filho falava (null em grupo) */
  contact?: AlertContact | null;
}

/** Mapeamento de risco → cor (CSS variables) */
export const RISK_COLORS: Record<RiskCategory, string> = {
  safe: 'var(--pappo-safe)',
  bullying: 'var(--pappo-high)',
  violence: 'var(--pappo-critical)',
  scam: 'var(--pappo-medium)',
  sexual_content: 'var(--pappo-critical)',
  grooming: 'var(--pappo-critical)',
  self_harm: 'var(--pappo-high)',
  drugs: 'var(--pappo-high)',
};

/** Labels legíveis das categorias */
export const RISK_LABELS: Record<RiskCategory, string> = {
  safe: 'Seguro',
  bullying: 'Bullying',
  violence: 'Violência',
  scam: 'Golpe / Fraude',
  sexual_content: 'Conteúdo Sexual',
  grooming: 'Aliciamento',
  self_harm: 'Automutilação',
  drugs: 'Drogas',
};
